export default __webpack_public_path__ + "static/media/Show02.ddb586d0.svg";